<template>
  <div class="meterial-input-page" >
    <a-row :gutter="13">
      <a-col :span="24"  >
        <busStandardTeamConfig-modal   @chooseDepart="handleChooseDepart" ></busStandardTeamConfig-modal>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import BusStandardTeamConfigModal from './modules/BusStandardTeamConfigModal'

export default {
  data() {
    return {
      choosedWorkshopId:""
    }
  },
  methods: {
    handleChooseDepart(record){
      this.choosedWorkshopId=record.id
      let recordCopy=JSON.parse(JSON.stringify(record))
      recordCopy.departId=recordCopy.id;
      delete recordCopy.id;
    },
    handleCloseWorkshop(){
      this.choosedWorkshopId=''
    }
  },
  computed:{
  },
  components:{
    BusStandardTeamConfigModal
  }
}
</script>

<style lang="less" scoped>
.meterial-input-page{
  height: 100%;
}
</style>